import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  learnerEmailSelector,
  useSyncUserActivitiesMutation,
} from 'features/neovarsityManagement';
import AcademyModuleAsyncSelect from 'components/AcademyModuleAsyncSelect';
import styles from './NeoAcademyModuleInput.module.scss';

const parseAcademyModule = (academyModule) =>
  academyModule
    ? {
        label: academyModule?.name,
        value: academyModule?.id,
      }
    : null;

export default function NeoAcademyModuleInput({ value, disabled = false }) {
  const [academyModule, setAcademyModule] = useState('');

  const [syncUserActivities, { isSuccess, error }] =
    useSyncUserActivitiesMutation();

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Activities synced successfully');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      const errorMessage = error?.data?.message;
      if (errorMessage) {
        cogoToast.error(errorMessage);
      } else {
        cogoToast.error('Activities did not sync successfully');
      }
    }
  }, [error]);

  useEffect(() => {
    if (value) {
      setAcademyModule(parseAcademyModule(value));
    } else {
      setAcademyModule(null);
    }
  }, [value]);

  const handleAcademyModuleChange = useCallback((option) => {
    setAcademyModule(option);
  }, []);

  const learnerEmail = useSelector(learnerEmailSelector);

  const handleSyncUserActivities = useCallback(() => {
    syncUserActivities({
      learnerEmail,
      academyModule,
    });
  }, [academyModule, learnerEmail, syncUserActivities]);

  return (
    <>
      <div className="row">
        <AcademyModuleAsyncSelect
          category="core"
          value={academyModule}
          onChange={handleAcademyModuleChange}
          className={styles.input}
          isDisabled={disabled}
        />
      </div>
      <Tappable
        className="btn btn-primary m-v-xxs"
        disabled={academyModule === '' && learnerEmail === ''}
        component="button"
        type="submit"
        onClick={handleSyncUserActivities}
      >
        Sync activities
      </Tappable>
      <div>
        (Add user email and the module from dropdown to activate this button)
      </div>
    </>
  );
}

NeoAcademyModuleInput.propTypes = {
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
